export default {
  async getUsers ({ commit }, payload) {

    const res = await window.axios.get('/users', {
      params: {...payload}
    })

    commit('SET_USERS', res.data || [])

    return res.data
  }
}
